import type { OrderAddressPositionTypeEnum } from "@daytrip/api";

export const ORDER_ADDRESS_APPROVAL_QUERY_KEY = "orderAddressApproval";

export const createAddressApprovalQueryKey = (orderId: string, positionType: OrderAddressPositionTypeEnum) =>
    `orderAddressApproval/${orderId}/${positionType}`;
